<template>
  <validator name="applicationValidation">
    <form id="applicationForm" class="row" v-show="!processingForm" novalidate>
      <h1 class="interested">Interested?</h1>
      <div class="form-group col-md-12">
        <label for="firstName">Name</label>
        <input v-validate:first-name="{ required: true, minlength: 2 }" type="text" class="form-control" id="firstName"
               v-model="form.firstName">
      </div>
      <div class="form-group col-md-12">
        <label for="lastName">Surname</label>
        <input v-validate:last-name="{ required: true, minlength: 2 }" type="text" class="form-control" id="lastName"
               v-model="form.lastName">
      </div>
      <div class="form-group col-md-12">
        <label for="email">Email</label>
        <input v-validate:email="['email']" type="text" class="form-control" id="email" v-model="form.email">
      </div>
      <div class="form-group col-md-12">
        <label for="phone">Phone Number</label>
        <input v-validate:phone="{ required: true}" type="tel" class="form-control" id="phone" v-model="form.phone">
      </div>
      <div class="form-group col-md-12">
        <label for="country">Country</label>
        <input v-validate:country="{ required: true }" type="text" class="form-control" id="country"
               v-model="form.country">
      </div>
      <div class="form-group col-md-12 thoughts">
        <p>You can share few thoughts with us (not necessary).</p>
      </div>
      <div class="form-group col-md-12">
        <label for="descriptionWhy">Why would you like to work for 507?</label>
        <textarea class="form-control" v-model="form.descriptionWhy" id="descriptionWhy" rows="1"></textarea>
      </div>
      <div class="form-group col-md-12">
        <label for="descriptionAchieve">What would be your goal with 507?</label>
        <textarea class="form-control" v-model="form.descriptionAchieve" id="descriptionAchieve" rows="1"></textarea>
      </div>
      <div v-validate-class class="form-group col-md-12 file-upload">
        <label class="file-label" for="file">Add Your CV File</label>
        <span class="filename">{{ form.file | filename }}</span>
        <input v-validate:file="{ required: true }" type="file" v-model="form.file" class="form-control-file btn-507"
               id="file">
      </div>
      <button type="button" v-on:click="createApplication" class="btn-507 center-block" id="applyApplication">Apply
      </button>
    </form>
  </validator>
    <div class="loading" v-show="processingForm">
      <h3>Processing your request</h3>
      <div class="spinner">
        <div class="mask">
          <div class="maskedCircle"></div>
        </div>
      </div>
  </div>
</template>

<style lang="sass">
  @import "../../assets/scss/colors"
  @import "../../assets/scss/variables"

  #applicationForm
    flex-direction: column

    .btn-507
      margin-top: 2em

    .file-upload
      margin-top: 2em !important

    .thoughts
      margin-top: 1.5em !important
      margin-bottom: 0em !important
      p
        margin: 0

    .form-group
      display: flex
      flex-direction: row
      margin: 0.3em 0
      flex: 1 1 auto

    label
      font-weight: bold
      text-transform: uppercase
      color: $black

    .filename
      height: $line-height + em

    .file-label,
    .filename
      cursor: pointer

    @keyframes spin
      from
        transform: rotate(0deg)
      to
        transform: rotate(360deg)

  $loadingSize: 10em
  .loading
    display: flex
    flex-direction: column
    justify-content: center
    align-content: center
    width: 100%

    h3
      align-self: center
      margin-bottom: 3em

    .maskedCircle
      width: $loadingSize
      height: $loadingSize
      border-radius: 50%
      border: 3px solid $text-dark-primary

    .mask
      width: $loadingSize / 2
      height: $loadingSize / 2
      overflow: hidden

    .spinner
      align-self: center
      width: $loadingSize
      height: $loadingSize
      animation: spin 1s infinite linear


  @media screen and (max-width: map_get($grid-breakpoints, "md"))
    #applicationForm

      .form-group
        flex-direction: column

        input,
        textarea,
        .filename
          margin-left: 0
</style>

<script>
  import {showAlert} from '../../vuex/actions'

  export default{
    data() {
      return {
        form: {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          country: "",
          file: "",
          descriptionWhy: "",
          descriptionAchieve: "",
        },
        // When data is uploading show loading
        processingForm: false
      }
    },
    vuex: {
      getters: {
        alerts: state => state.alerts
      },
      actions: {
        alert: showAlert
      }
    },
    methods: {
      createApplication () {

        // Validate data
        if (!this.$applicationValidation.valid) {

          this.alert('Error!', 'Make sure there aren\'t any red underlined fields!');
        } else {

          $("#applyApplication").prop("disabled");

          var form = new FormData();

          form.append("firstName", this.form.firstName);
          form.append("lastName", this.form.lastName);
          form.append("email", this.form.email);
          form.append("phone", this.form.phone);
          form.append("country", this.form.country);
          form.append("descriptionWhy", this.form.descriptionWhy);
          form.append("descriptionAchieve", this.form.descriptionAchieve);
          form.append("file", $('#file')[0].files[0]);

          this.processingForm = true;

          this.$http.post('jobs/' + this.$parent.job.id, form).then((response) => {
            this.$router.go('/applications/' + response.data.data.uuid);
          }, (response) => {
            this.alert('Error!', response.data.message);
            this.processingForm = false;
            // If error that email was already used, we force form error (red line)
            if (response.data.type === 1) {
              this.$setValidationErrors([
                { field: "email", message: response.data.message, validator: "applicationValidation"}
              ])
            }
          });

        }
      }
    },
    ready () {
      $('textarea').each(function () {
        this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
      }).on('input', function () {
        this.style.height = 'auto';
        var fix = 0;
        if (this.scrollHeight === 40) {
          fix = 16
        }
        this.style.height = (this.scrollHeight) - fix + 'px';
      });

      // Make span manipulate file upload
      $('.filename').click(function () {
        $('#file').click();
        return false;
      });
    }
  }
</script>



// WEBPACK FOOTER //
// applicationForm.vue?3658de19